import React from 'react';
import gas from '../images/gas.jpg';
import plumber from '../images/plumber.jpg';
import electrician from '../images/electrician.jpg';
import abseilers from '../images/abseilers.jpg';
import roofers from '../images/roofers.jpg';
import drain from '../images/drain.jpg';
import cleaners from '../images/cleaners.jpg';
import painter from '../images/painter.jpg';
import maintenance from '../images/maintenance.jpg';
import waste from '../images/waste.jpg';

const servicesList = [
  { title: 'Gas Engineers', image: gas, alt: 'Gas engineer at work' },
  { title: 'Plumbers', image: plumber, alt: 'Plumber fixing pipes' },
  { title: 'Electricians', image: electrician, alt: 'Electrician working' },
  { title: 'Abseilers', image: abseilers, alt: 'Abseilers working on building' },
  { title: 'Roofers', image: roofers, alt: 'Roofer working on roof' },
  { title: 'Drain Cleaners', image: drain, alt: 'Drain cleaning service' },
  { title: 'Domestic Cleaners', image: cleaners, alt: 'Cleaning service' },
  { title: 'Painters & Decorators', image: painter, alt: 'Painter decorating' },
  { title: 'General Maintenance', image: maintenance, alt: 'Maintenance work' },
  { title: 'Waste Removal', image: waste, alt: 'Waste removal service' }
];

const Services = () => {
  return (
    <section className="services">
      <div className="container">
        <h2 className="services__title" style={{ textAlign: 'left' }}>Our Services</h2>
        <div className="services__grid">
          {servicesList.map((service, index) => (
            <a
              key={index}
              href={`mailto:info@fix-it-all-scotland.com?subject=Enquiry: ${service.title}`}
              className="services__card"
            >
              <div className="services__image-container">
                <img
                  src={service.image}
                  alt={service.alt}
                  className="services__image"
                />
              </div>
              <h3 className="services__card-title">{service.title}</h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
